import { random } from 'lodash';
import Enemy from '../../enemy/Enemy';
import Entry from './entry/Entry';

const RANGE_X = 10;
const OFFSET_Y = 100;

export default class Damage extends Phaser.GameObjects.Container {
    private entries: Entry[] = [];

    constructor(scene: Phaser.Scene) {
        super(scene, 0, 0);
        this.scene.layers.vfx.add(this);

        this.setupListeners();
    }

    setupListeners() {
        this.scene.events.on(Enemy.EVENTS.DAMAGED, this.onEnemyDamaged, this);
    }

    onEnemyDamaged(x: number, y: number, damage: number, isCrit: boolean, isEnrageHit: boolean, heroId: number, isAura: boolean = false) {
        let entry = this.getEntry()!;
        x = random(x - RANGE_X, x + RANGE_X);
        y -= OFFSET_Y;

        entry.launch(x, y, damage, { isAura, isCrit, isEnrageHit });
    }

    getEntry() {
        let entry = null;

        if (this.entries.length === 0) {
            entry = new Entry(this.scene, 0, 0);
            entry.on('done', this.onEntryDone, this);
            this.add(entry);
        } else {
            entry = this.entries.pop()!;
            entry.activate();
        }

        return entry;
    }

    onEntryDone(entry: Entry) {
        entry.deactivate();
        this.entries.push(entry);
    }

    destroy() {
        this.scene.events.off(Enemy.EVENTS.DAMAGED, this.onEnemyDamaged, this);
        super.destroy();
    }
}
